/*
 * Look story: a window over the product page with a look's photos, opened from
 * the circles (snippets/looks-for-product-circle.liquid). One shared <dialog>
 * for the page; X, Escape or the backdrop close it and the page stays where it
 * was. Focus goes to the window itself and comes back through the dialog, so a
 * tap leaves no focus ring in Safari while the keyboard still returns to the
 * circle.
 *
 * The circles of a row play like Instagram highlights. A tap on the right or
 * left of the photo moves a photo, and past the last or first photo it moves
 * on to the next or previous look; a sideways swipe moves a whole look; past
 * the last look the window closes. A row with a single look keeps the plain
 * gallery: swipe and taps move photos and stop at the ends.
 */
(function () {
  var SWIPE_PX = 40;

  // Where a step lands. at = { look, looks, photo, photos }; by is 'photo' for
  // taps, arrows and keys, 'look' for a swipe.
  function stepTarget(at, step, by) {
    if (by === 'photo' || at.looks < 2) {
      var photo = at.photo + step;
      if (photo >= 0 && photo < at.photos) return { action: 'photo', photo: photo };
      if (at.looks < 2) return { action: 'stay' };
    }
    var look = at.look + step;
    if (look >= at.looks) return { action: 'close' };
    if (look < 0) return { action: 'stay' };
    return { action: 'look', look: look };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { stepTarget: stepTarget };
  }
  if (typeof window === 'undefined' || window.LookStory) return;

  var dialog = null;
  var row = [];
  var look = 0;
  var photo = 0;
  var swipe = null;
  var swiped = false;

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'look-story';
    dialog.tabIndex = -1;
    dialog.innerHTML =
      '<div class="look-story__frame" data-look-story-frame></div>' +
      '<div class="look-story__count" aria-live="polite" aria-atomic="true" data-look-story-count></div>' +
      '<button type="button" class="look-story__nav look-story__nav--prev" data-look-story-step="-1" aria-label="Previous photo">&#8249;</button>' +
      '<button type="button" class="look-story__nav look-story__nav--next" data-look-story-step="1" aria-label="Next photo">&#8250;</button>' +
      '<button type="button" class="look-story__close" data-look-story-close aria-label="Close">&times;</button>';
    document.body.appendChild(dialog);

    dialog.addEventListener('click', function (event) {
      // the click a mouse sends after a swipe is not a tap
      if (swiped) {
        swiped = false;
        event.preventDefault();
        return;
      }
      if (event.target.closest('[data-look-story-close]')) return close();
      var step = event.target.closest('[data-look-story-step]');
      if (step) return go(Number(step.getAttribute('data-look-story-step')), 'photo');
      // a tap on the photo moves like a story: right side forward, left side back
      var slide = event.target.closest('.look-story__slide');
      if (slide) {
        var rect = dialog.getBoundingClientRect();
        go(event.clientX > rect.left + rect.width / 2 ? 1 : -1, 'photo');
        return;
      }
      if (event.target === dialog) close();
    });
    dialog.addEventListener('pointerdown', function (event) {
      swiped = false;
      swipe = event.isPrimary && row.length > 1 ? { id: event.pointerId, x: event.clientX, y: event.clientY } : null;
    });
    dialog.addEventListener('pointerup', function (event) {
      if (!swipe || event.pointerId !== swipe.id) return;
      var dx = event.clientX - swipe.x;
      var dy = event.clientY - swipe.y;
      swipe = null;
      if (Math.abs(dx) < SWIPE_PX || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      swiped = true;
      go(dx < 0 ? 1 : -1, 'look');
    });
    dialog.addEventListener('pointercancel', function () {
      swipe = null;
    });
    dialog.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('look-story-open');
      dialog.querySelector('[data-look-story-frame]').innerHTML = '';
      row = [];
      swipe = null;
    });
    dialog.addEventListener('keydown', function (event) {
      swiped = false;
      if (event.key === 'ArrowRight') go(1, 'photo');
      if (event.key === 'ArrowLeft') go(-1, 'photo');
    });
  }

  function slides() {
    return dialog.querySelector('[data-look-story-slides]');
  }

  function count() {
    var track = slides();
    var total = track ? track.children.length : 0;
    var counter = dialog.querySelector('[data-look-story-count]');
    counter.hidden = total < 2;
    counter.textContent = (photo + 1) + ' / ' + total;
    dialog.classList.toggle('look-story--single', total < 2 && row.length < 2);
  }

  // a single look scrolls natively, so the counter follows the scroll
  function onScroll() {
    if (row.length > 1) return;
    var track = slides();
    photo = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
    count();
  }

  function show(index) {
    photo = index;
    slides().children[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    count();
  }

  function render(handle, from) {
    var template = document.querySelector('template[data-look-story="' + CSS.escape(handle) + '"]');
    if (!template) return false;
    var frame = dialog.querySelector('[data-look-story-frame]');
    frame.innerHTML = '';
    frame.appendChild(document.importNode(template.content, true));
    frame.classList.remove('look-story__frame--next', 'look-story__frame--prev');
    if (from) {
      void frame.offsetWidth;
      frame.classList.add('look-story__frame--' + from);
    }
    var name = frame.querySelector('.look-story__name');
    dialog.setAttribute('aria-label', name ? name.textContent : '');
    slides().addEventListener('scroll', onScroll, { passive: true });
    photo = 0;
    count();
    return true;
  }

  function travel(index, from) {
    if (!render(row[index].getAttribute('data-look-story-open'), from)) return close();
    look = index;
    if (!dialog.contains(document.activeElement)) dialog.focus({ preventScroll: true });
  }

  function go(step, by) {
    var track = slides();
    if (!track) return;
    var to = stepTarget({ look: look, looks: row.length, photo: photo, photos: track.children.length }, step, by);
    if (to.action === 'photo') show(to.photo);
    else if (to.action === 'look') travel(to.look, step > 0 ? 'next' : 'prev');
    else if (to.action === 'close') close();
  }

  function open(handle, opener) {
    if (!dialog) build();
    var list = opener && opener.closest('[data-look-story-row]');
    row = list ? Array.prototype.slice.call(list.querySelectorAll('[data-look-story-open]')) : [];
    look = row.indexOf(opener);
    if (look < 0) {
      row = [];
      look = 0;
    }
    if (!render(handle)) return;
    dialog.classList.toggle('look-story--travel', row.length > 1);
    document.documentElement.classList.add('look-story-open');
    if (!dialog.open) dialog.showModal();
    dialog.focus({ preventScroll: true });
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-look-story-open]');
    if (!opener) return;
    event.preventDefault();
    open(opener.getAttribute('data-look-story-open'), opener);
  });

  window.LookStory = { open: open, close: close };
})();
